import { render, staticRenderFns } from "./widgetFwWebTrafTop10.vue?vue&type=template&id=58610f83&scoped=true&"
import script from "./widgetFwWebTrafTop10.vue?vue&type=script&lang=js&"
export * from "./widgetFwWebTrafTop10.vue?vue&type=script&lang=js&"
import style0 from "./widgetFwWebTrafTop10.vue?vue&type=style&index=0&id=58610f83&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58610f83",
  null
  
)

export default component.exports